import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-solid",
  "use": "check-solid-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"check-solid\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M11 0a11 11 0 1011 11A11 11 0 0011 0zm5.2 8.3L10 14.4a1 1 0 01-1.5 0l-2.8-2.8a1 1 0 010-1.5 1 1 0 011.5 0l2 2 5.4-5.3a1 1 0 01.7-.3 1 1 0 01.8.3 1 1 0 010 1.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol